import * as lan from '../common/script/common_lan.js';

import ReactDom from 'react-dom';
 
const PopupDom = ({ children }) => {
    const el = document.getElementById('root');
    return ReactDom.createPortal(children, el);
};
 
export default PopupDom;